import { apiRequest } from "./client";

const base = (guildId) => `/api/v1/guilds/${guildId}/reaction-roles`;

export const getReactionRoles = (guildId) => apiRequest(base(guildId));
export const addReactionRole = (guildId, payload) =>
  apiRequest(base(guildId), { method: "POST", body: payload });
export const deleteReactionRole = (guildId, messageId, roleId) =>
  apiRequest(`${base(guildId)}/${messageId}/${roleId}`, { method: "DELETE" });
